module.exports = __webpack_public_path__ + "img/Combined_Shape.f749cab2.svg";